<template>
  <div :id="no" style="width:300px;height:200px;margin-top:20px">

  </div>
</template>

<script>
export default {
  name: 'LockanRadar',
  props: {
    data: {
      type: Array,
      default: null
    },
    data1: {
      type: Array,
      default: null
    },
    indicator: {
      type: Array,
      default: null
    },
    no: {
      type: String
    }
  },
  mounted () {
    // 基于准备好的dom，初始化echarts实例
    let chart = document.getElementById(this.no)
    let myChart = this.$echarts.init(chart)
    // let legenddata=[]
    //   data.forEach(item=>{
    //     legenddata.push(item.name)
    // })
   // console.log(this.indicator, this.data, this.data1)
    let {indicator, data, data1} = this
    // 绘制图表
    myChart.setOption({
      title: {
        text: '雷达图'
      },
      tooltip: {},
      legend: {
        data1
      },
      radar: {
        // shape: 'circle',
        name: {
          textStyle: {
            color: '#fff',
            backgroundColor: '#999',
            borderRadius: 3,
            padding: [3, 5]
          }
        },
        indicator,
        center: ['50%', '50%'],
        radius: 80
      },
      series: [{
        // name: '预算 vs 开销（Budget vs spending）',
        type: 'radar',
        data
      }]
    });
  }
}
</script>
